import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

export const PlanRequiredModal = ({ isOpen, onClose, errorDetail }) => {
  const navigate = useNavigate();
  const requiredPlan = errorDetail?.required_plan || 'pro';
  const currentPlan = errorDetail?.current_plan || 'free';

  const handleUpgrade = () => {
    onClose();
    navigate('/pricing');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-100 rounded-full">
              <Lock className="w-5 h-5 text-blue-600" />
            </div>
            <DialogTitle>Upgrade Required</DialogTitle>
          </div>
          <DialogDescription className="pt-4">
            This feature requires a <strong>{requiredPlan.toUpperCase()}</strong> plan or higher.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="bg-muted rounded-lg p-4">
            <p className="text-sm mb-2">
              <span className="text-muted-foreground">Current Plan:</span>{' '}
              <strong>{currentPlan.toUpperCase()}</strong>
            </p>
            <p className="text-sm text-muted-foreground">
              Upgrade to <strong>{requiredPlan.toUpperCase()}</strong> to unlock Case Review mode and
              advanced grievance analysis features.
            </p>
          </div>
          <div className="text-sm">
            <strong className="text-foreground">Pro Plan Includes:</strong>
            <ul className="mt-2 space-y-1 ml-4 text-muted-foreground">
              <li>• 60 credits per month</li>
              <li>• Case Review mode (5 credits/use)</li>
              <li>• Dual-corpus analysis (CBA + case documents)</li>
              <li>• PDF export & saved history</li>
            </ul>
          </div>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto">
            Cancel
          </Button>
          <Button onClick={handleUpgrade} className="w-full sm:w-auto">
            Upgrade to {requiredPlan.toUpperCase()}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
